import { UnderlineText } from "components/atoms/text/Text";
import { ForwardedRef, forwardRef, useMemo, useState } from "react";
import * as s from "../SignupStyled";
import {
  ResellerUserInfo,
  SIGNUP_UPDATE_TYPE,
  SignupUserInfo,
} from "api/interfaces/authInterface.interface";
import TermsModal from "pages/terms/text/TermsModal";

interface Props {
  onChangeUserInfo: (type: SIGNUP_UPDATE_TYPE, data: string | boolean) => void;
  userInfo: SignupUserInfo | ResellerUserInfo;
  label?: string;
  fieldKey: string;
  type: SIGNUP_UPDATE_TYPE;
  termsContent: React.ReactNode;
  termsTitle?: string;
}

function Agreement(props: Props, ref?: ForwardedRef<HTMLInputElement>) {
  const {
    onChangeUserInfo,
    userInfo,
    label = "End User License Agreement",
    fieldKey,
    type,
    termsContent,
    termsTitle = "End User License Agreement",
  } = props;
  const [isOpen, setIsOpen] = useState(false);
  const checked = useMemo(() => {
    return userInfo[
      fieldKey as keyof (SignupUserInfo | ResellerUserInfo)
    ] as boolean;
  }, [userInfo, fieldKey]);
  return (
    <>
      <s.AgreementWrapper
        onClick={() => setIsOpen(true)}
        data-testid="auth-signup-common-agreement-wrapper-set-is-open"
      >
        <input
          id="dw_signup_input_userAgree"
          key="signup_input_userAgree"
          type="checkbox"
          ref={ref}
          checked={checked}
          readOnly
        />
        I agree to the
        <UnderlineText fontSize={14}>{label}.</UnderlineText>
      </s.AgreementWrapper>

      {isOpen && (
        <TermsModal
          title={termsTitle}
          content={termsContent}
          onModal={() => setIsOpen(false)}
          onAgree={() => {
            onChangeUserInfo(type, true);
            setIsOpen(false);
          }}
        />
      )}
    </>
  );
}
export default forwardRef(Agreement);
